<template>
  <translate
    tag="time"
    :tt="{
      originalDate: originalDate,
      changedDate: changedDate,
    }"
    >Changed from {originalDate, puDate, full} on {changedDate, puDate, full}
    {changedDate, puDate, time}</translate
  >
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class BookingDateChanged extends Vue {
  @Prop({ required: true })
  originalDate: string

  @Prop({ required: true })
  changedDate: string
}

export default toNative(BookingDateChanged)
</script>
<style scoped>
time {
  font-size: var(--small);
  font-weight: normal;
  margin-right: 0.5em;
  color: var(--colour-text-light);
}
</style>
